import HttpClienteSeguroClass from '../../Servicios/HttpClienteSeguroClass';

// Se encacarga de listar tabla contactos clientes
//CustomerId: id del cliente a consultar
//UserId: id usuario logueado
export const ObtenerTablaRegistros = (registro) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroClass.post('/CustomerContact/Listado/', registro).then(response => {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    });
};

// metodo para crear nuevo registro, recibe:
//const objetoRegistro = {
//    CustomerId: id cliente seleccionado
//    ContactTypeId: id tipo contacto
//    CountryCode: código pais
//    Phone: número telefónico max 20 caracteres
//    Observation: observaciones max 200 caracteres 
//    CompanyId: id compañía usuario logueado
//    UserId: id usuario logueado
//};
export const CrearNuevoRegistro = (registro) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroClass.post("/CustomerContact/Guardar/", registro).then(response => {
            resolve(response);
        })
            .catch(error => {
                resolve(error.response);
            });
    });
};


// Se encacarga de la actualizacion de un registro, recibe:
//const objetoRegistro = {
//    CustomerContactId: id del registro a actualizar (registro cliente/contacto),
//    CustomerId: id cliente seleccionado
//    ContactTypeId: id tipo contacto
//    CountryCode: código pais
//    Phone: número telefónico max 20 caracteres
//    Observation: observaciones max 200 caracteres 
//    CompanyId: id compañía usuario logueado
//    UserId: id usuario logueado
//};
export const ActualizarRegistro = (registro) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroClass.post("/CustomerContact/Actualizar/", registro).then(response => {
            resolve(response);
        })
            .catch(error => {
                resolve(error.response);
            });
    });
};

// Se usa para eliminar un registro, recibe:
//const data = {
//    CustomerContactId: id del registro a eliminar (registro cliente/contacto),
//    CompanyId: id compañía usuario logueado
//    UserId: id usuario logueado
//};
export const EliminarRegistro = (data) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroClass.post("/CustomerContact/Eliminar/", data).then(response => {
            resolve(response);
        })
            .catch(error => {
                resolve(error.response);
            });
    });
};


// Se usa para establecer un registro favorito, recibe:
//const data = {
//    CustomerContactId: id del registro a eliminar (registro cliente/contacto),
//    CustomerId: id cliente seleccionado
//    CompanyId: id compañía usuario logueado
//    UserId: id usuario logueado
//    PeticionUsuario: Solicitud de permiso para la operacion
//};
export const EstablecerFavorito = (data) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroClass.post("/CustomerContact/Favorito/", data).then(response => {
            resolve(response);
        })
            .catch(error => {
                resolve(error.response);
            });
    });
};